import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "../../../../components/ui/card";

const Topics: React.FC = () => {
	const topics = [
		{
			id: "frontend",
			title: "フロントエンド開発",
			description: "モダンなWeb開発の基礎から応用まで",
			examples: ["React", "TypeScript", "Next.js", "CSS設計"],
			icon: "💻",
		},
		{
			id: "backend",
			title: "バックエンド開発",
			description: "サーバーサイド技術とデータベース",
			examples: ["Node.js", "Python", "SQL", "API設計"],
			icon: "⚙️",
		},
		{
			id: "data-science",
			title: "データサイエンス",
			description: "データ分析と機械学習の基礎",
			examples: ["Python", "統計", "機械学習", "データ可視化"],
			icon: "📊",
		},
		// ... 他のトピック
	];

	return (
		<section className="py-16">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<h2 className="text-3xl font-bold mb-8">取り扱うトピック</h2>
				<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
					{topics.map((topic) => (
						<Card key={topic.id}>
							<CardHeader>
								<div className="flex items-center gap-2">
									<span className="text-2xl">{topic.icon}</span>
									<CardTitle>{topic.title}</CardTitle>
								</div>
								<CardDescription>{topic.description}</CardDescription>
							</CardHeader>
							<CardContent>
								<ul className="list-disc list-inside space-y-2">
									{topic.examples.map((example) => (
										<li key={example}>{example}</li>
									))}
								</ul>
							</CardContent>
						</Card>
					))}
				</div>
			</div>
		</section>
	);
};

export default Topics;
